/**
 * Generates a random alphanumeric string of a specified length.
 *
 * ⚠️ **SECURITY WARNING:** This function uses `Math.random()` and is **NOT cryptographically secure**.
 * Do NOT use this for:
 * - Passwords
 * - Authentication tokens (e.g., session IDs, JWT secrets)
 * - Any security-critical keys
 *
 * For security-sensitive use cases, use `crypto.randomUUID()` (Node.js/Browser) or `node:crypto` instead.
 *
 * ✅ **Valid Use Cases:**
 * - Generating unique IDs for UI elements (e.g., form inputs)
 * - Creating temporary filenames
 * - Test data generation
 *
 * @param length - The length of the random string to generate.
 * @returns A random alphanumeric string.
 */
export const generateRandomString = (length: number): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};
